__webpack_require__.p = "/world-update/";